import React from 'react'
import {CodeExplanationComponent} from "../CodeExplanation/CodeExplanationComponent";

export function ActivityRecordHelpComponent() {
    return <>
        <CodeExplanationComponent/>
    </>
}